// Centralised, editable site content. Replace placeholders as real content arrives.

export const IMG = {
  hero: "/hero.jpg",
  studioTexture: "https://static.prod-images.emergentagent.com/jobs/9bdf0fa6-6699-4d7d-812f-b3490eea960d/images/5a7d403da2647dbd714da55e37cc5e214aa0f6fd7986b57ad96eb3d7b580437d.jpeg",
  materialStudy: "https://static.prod-images.emergentagent.com/jobs/9bdf0fa6-6699-4d7d-812f-b3490eea960d/images/f0d481439d0f5bb4a7b5fc72a5b7acaa0a4adda64809c186c3e3e3419fc6f56a.jpeg",
  logo: "https://customer-assets-cm19k8pv.emergentagent.net/job_materiality-studio-1/artifacts/sepqrxrl_A%26H%20Logo.png",
  hydePark: "https://static.prod-images.emergentagent.com/jobs/9bdf0fa6-6699-4d7d-812f-b3490eea960d/images/77433a7c610a99417719167da0e33983e86f9423cd5a4114122da8180ce705dd.jpeg",
  chelsea: "https://customer-assets-cm19k8pv.emergentagent.net/job_materiality-studio-1/artifacts/bc5aqxjf_ChatGPT%20Image%20Aug%2017%2C%202026%2C%2003_34_15%20PM.png",
  hampstead: "https://static.prod-images.emergentagent.com/jobs/9bdf0fa6-6699-4d7d-812f-b3490eea960d/images/35bf653455149fadef508d6f0ca021fe2006ed234d45d5fcebed87a2008532a1.jpeg",
  journalMaterials: "https://static.prod-images.emergentagent.com/jobs/9bdf0fa6-6699-4d7d-812f-b3490eea960d/images/c1062caaf1adf74ae197bfa269b28d7fef4f69b69ecd164d2dfc3568b3a044d5.jpeg",
  journalArt: "https://static.prod-images.emergentagent.com/jobs/9bdf0fa6-6699-4d7d-812f-b3490eea960d/images/29d222c432c3fbed8220f8a1cfa70ebd5c1e80ce6da47ef52b9560840f475c1d.jpeg",
  journalPeriod: "https://static.prod-images.emergentagent.com/jobs/9bdf0fa6-6699-4d7d-812f-b3490eea960d/images/07c830e49d3f5b216ac2da59b33ae96548a8a66fa868b8902440c90ade58975f.jpeg",
};

export const SITE = {
  name: "Arc & Hollow",
  positioning: "A London interior architecture and design studio creating considered residential interiors through architecture, materiality, art and bespoke detail.",
  brandThought: "The hidden layers define the experience.",
  // Editable placeholders — replace before launch.
  email: "arc@arcandhollow.co.uk",
  phone: "020 3886 3446",
  phoneHref: "+442038863446",
  instagram: "@arcandhollow",
  instagramUrl: "https://instagram.com/arcandhollow",
  location: "London, United Kingdom",
};

export const NAV = [
  { label: "Studio", to: "/studio" },
  { label: "Projects", to: "/projects" },
  { label: "Services", to: "/services" },
  // "Journal" temporarily archived from public navigation — route preserved in App.js and can be restored here.
  { label: "Contact", to: "/contact" },
];

// Configurable enquiry-form options.
export const SERVICE_OPTIONS = [
  "Full-Service Residential Interiors",
  "Interior Architecture & Renovation",
  "Styling, Art & FF&E",
  "Other",
];

export const PROPERTY_TYPES = [
  "Apartment", "Townhouse", "Period property", "New build", "Other",
];

// Editable placeholder ranges — confirm with studio before launch.
export const BUDGET_RANGES = [
  "To be discussed",
  "£75k – £150k",
  "£150k – £350k",
  "£350k – £750k",
  "£750k +",
];

export const TIMELINES = [
  "Exploring ideas", "Within 3 months", "3 – 6 months", "6 – 12 months", "Flexible",
];

export const REFERRALS = [
  "Instagram", "Referral", "Search", "Publication", "Other",
];
